import { useCallback, useEffect, useState } from 'react';
import {
  fetchPricesNotSpecial,
  hasSpecialPrice as hasSpecialPriceUtil,
} from 'shared/services/special-price.service';

export function usePricesNotSpecial() {
  const [pricesNotSpecial, setPricesNotSpecial] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchPricesNotSpecial()
      .then((data) => {
        if (!cancelled) setPricesNotSpecial(data);
      })
      .catch(() => {
        if (!cancelled) setPricesNotSpecial([]);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const hasSpecialPrice = useCallback(
    (amount: number) => hasSpecialPriceUtil(amount, pricesNotSpecial),
    [pricesNotSpecial]
  );

  return { pricesNotSpecial, isLoading, hasSpecialPrice };
}
